import { createClient } from "@borderless/json-rpc";
import type { API } from "./types";

export const client = createClient<API>(async payload => {
  //@ts-ignore
  const wcApiUrl = window.__PAYMENT_FORM_API_URL__
  //@ts-ignore
  const api = wcApiUrl || (window.isProduction === true ? 'https://donateou.org' : '')

  const res = await fetch(`${api}/api2`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });

  return res.json();
});